import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Comment } from "@air/next-icons";
export const CommentCount = (param)=>{
    let { count = 0 } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mr-2 flex items-center text-12 text-grey-11",
        children: [
            /*#__PURE__*/ _jsx(Comment, {
                className: "mr-1 flex size-4"
            }),
            count
        ]
    });
};
